// Copyright (c) Move Closer 2022.

import { ValidationRules } from '../../../shared/molecules/Form'

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl>
 */
export const changeEmailFormValidatorsMap: ValidationRules = {
  email: 'required|string|email',
  password: 'required'
}
